<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                left-text="返回"
                fixed
                title="菜品分类"
                left-arrow
                right-text="新增菜品分类"
                @click-left="onClickLeft"
                @click-right="onClickRight"

        >
            <!--通过插槽自定义导航栏右侧的内容 end-->
        </van-nav-bar>
        <!--导航栏 end-->
        <!-- 列表 start-->
        <van-grid :column-num="3" :border="false" style="margin-top: 1rem">
            <van-grid-item  text="菜品分类名称" />
            <!-- <van-grid-item  text="菜品分类图片" /> -->
            <van-grid-item  text="排序值" />
            <van-grid-item  text="操作" />
        </van-grid>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="init"
        >
            <van-cell v-for="item in list" :key="item.id" @click.prevent="footclass_info(item.id)">
                <van-grid :column-num="3" :border="false">
                    <van-grid-item :text="item.name" />
                    <!-- <van-grid-item>
						<van-image
						  width="50"
						  height="50"
						  :src="Config.baseURL+item.image"
						/>
                    </van-grid-item> -->
                    <van-grid-item :text="String(item.rank)" />
                    <van-grid-item>
                        <van-button @click.stop="foodclass_detail(item.id)" style="width: 1.5rem;height: 0.6rem;position:relative; left: 0.2rem;" size="small"  type="danger">删除</van-button>
                    </van-grid-item>

<!--                    <van-grid-item v-if="item.is_audit_status == 1">审核中</van-grid-item>-->
<!--                    <van-grid-item v-if="item.is_audit_status == 0">已审核</van-grid-item>-->
                </van-grid>
            </van-cell>
        </van-list>
        <!-- 列表 end-->
    </div>
</template>

<script>
    import Vue from 'vue';
    import {List, Grid, GridItem,Dialog, Notify} from 'vant';
	import Config from "../../../config";
    // import VueCookie from "vue-cookies";

    Vue.use(Grid);
    Vue.use(GridItem);
    Vue.use(List);

    export default {
        name: "FoodClassList",
        data(){
            return{
                list: [],
                page:1,
                limit:10,
                loading: false,
                finished: false,
            }
        },
        methods:{
            // 返回上一级
            onClickLeft() {
                // 返回商户信息
                this.$router.push('/CodeOrder');
            },
            onClickRight(){
                this.$router.push('/FoodClassAdd')
            },
            init() {
                var that = this;
                // var salesmanInfo = VueCookie.get("salesmanInfo");
                this.$http.post('/wechat/api.store_class/listClass', {
                    
                        // id: salesmanInfo.id,
                        pageNum: that.page,
                        pageSize:that.limit
                    
                }).then(response => {
                    // 加载状态结束
                    that.loading = false;
                    // console.log(response.data.data)
                    that.list = that.list.concat(response.data.rows)
                    // 页码
                    that.page++;
                    // this.finished = true;
                    if (response.data.rows.length < that.limit)
                    {
                        that.finished = true;
                    }
                });
            },
            footclass_info(id) {
                // this.$router.push("/SalesmanUpdate/"+id);
                this.$router.push({path:"/FoodClassUpdate", query:{id:id}})
                // this.$router.push({path:"/SalesmanUpdate", params:{id:id}})
            },
            foodclass_detail(id){
                Dialog.confirm({
                    title: '删除菜品分类',
                    message: '确定删除该分类吗?',
                })  .then(() => {
                    this.$http.get('/wechat/api.store_class/delClass', {params:
                        {
							id:id,
							// openid: window.localStorage.getItem("openid")
                        }
                    }).then(response => {
                        if (response && response.body.code== 200) {
                            Notify({type: 'success', message: response.body.msg});
                            setTimeout(()=>{
                                this.$router.go(0)
                            },200)

                        }else {
                            Notify({type: 'danger',message:response.body.msg});
                        }
                    })
                })


            },
        },

    }
</script>

<style scoped>

</style>
